import React, { ReactNode } from "react"
import { BlockField, BlockFieldInputs } from "../../Components/Block"

interface UnitSelectFieldProps {
  label: string;
  name: string;
  defaultValue?: string | number;
  options: ReactNode[];
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

// Shared field for a single unit setting: a labelled <select> populated with the
// unit's enum options. Rendered once per unit by UnitsView.
export function UnitSelectField({ label, name, defaultValue, options, onChange }: UnitSelectFieldProps) {
  return (
    <BlockField label={label} className="block_field_small_8">
      <BlockFieldInputs>
        <select className="select-setting" name={name} defaultValue={defaultValue} onChange={onChange}>
          {options}
        </select>
      </BlockFieldInputs>
    </BlockField>
  );
}
